// extracted by mini-css-extract-plugin
export var involved = "involved-module--involved--tvDlR";
export var involvedCont = "involved-module--involvedCont--mbjbQ";
export var involvedTitle = "involved-module--involvedTitle--F7mYN";
export var leftInBg = "involved-module--leftInBg--zJKWE";
export var involvedinnLeft = "involved-module--involvedinnLeft--fS3Tm";
export var involvedInn = "involved-module--involvedInn--rh0iZ";
export var rightInBg = "involved-module--rightInBg--nInGI";
export var involvedInnRight = "involved-module--involvedInnRight--Lhi-g";
export var invCont = "involved-module--invCont--q+uUm";